import { Box, Paper, Typography, styled } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const ScorePanelContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  maxWidth: "100%",
  marginTop: theme.spacing(4),
  borderRadius: "3px",
  border: `2px solid ${theme.palette.blue[600]}`,
}))

export const IconRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(2),
}))

export const ScoreColumn = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
})

export const ScoreLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.blue[600],
  fontWeight: 'bold',
  marginBottom: '0 !important',
}))

export const SubScoreLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.blue[600],
  marginBottom: '0 !important',
}))

export const InfoIcon = styled(FontAwesomeIcon)(({ theme }) => ({
  color: theme.palette.blue[600],
}))
